/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DateRangeValue } from './date-range-value';
import { TrendPlan } from './trend-plan';
import { PeriodComparison } from './period-comparison';
import { ResultFreshness } from './result-freshness';


export interface KpiExecutionResponseDto { 
    /**
     * True when the rows came from the query-result cache instead of a warehouse run.
     */
    cacheHit?: boolean;
    /**
     * Warehouse run time in milliseconds once the query finished. Absent on a cache hit.
     */
    durationMs?: number;
    /**
     * Milliseconds since the warehouse run started, while it is still running.
     */
    elapsedMs?: number;
    /**
     * True when the run took 5 s or more: tell the user how long it takes and what that means on a dashboard, and try a narrower period while revising it. Absent on a cache hit.
     */
    slow?: boolean;
    /**
     * QUERY_TIMEOUT when the warehouse stopped the query at the statement cap (60 s for dashboard tiles, 180 s for agent queries); narrow the date range or group by fewer values. QUERY_CANCELLED, with status cancelled, when the warehouse cancelled the query on request; run it again.
     */
    errorCode?: KpiExecutionResponseDto.ErrorCodeEnum;
    /**
     * fresh: computed inside the cache window. stale: an older result served at once while one background refresh runs; show computedAt. computing: the query is still queued or running.
     */
    freshness?: ResultFreshness;
    /**
     * When the rows were computed, for an \"as of\" label.
     */
    computedAt?: string;
    /**
     * Queued query execution id to poll through the safe-query results endpoint.
     */
    executionId: string;
    /**
     * The trend plan of a trend KPI; null for every other type.
     */
    trend: TrendPlan | null;
    /**
     * What the KPI\'s period parameter resolved to (before a trend\'s widening; with a comparison, cut at today); null when the KPI has no period parameter.
     */
    period: DateRangeValue | null;
    /**
     * Status after the requested waitMs: success or error means getQueryResults answers at once; pending or running means poll it.
     */
    status?: KpiExecutionResponseDto.StatusEnum;
    /**
     * The second run asked for with compareTo: the compared dates, how to show the change and its executionId (with waitMs, also its status). Null when compareTo is omitted or null, the KPI is not a count, amount or percentage, it has no period date range, or the range has no start or starts after today. A failed comparison carries error and leaves the KPI\'s own run as it is.
     */
    comparison?: PeriodComparison | null;
}
export namespace KpiExecutionResponseDto {
    export const ErrorCodeEnum = {
        QueryTimeout: 'QUERY_TIMEOUT',
        QueryCancelled: 'QUERY_CANCELLED'
    } as const;
    export type ErrorCodeEnum = typeof ErrorCodeEnum[keyof typeof ErrorCodeEnum];
    export const StatusEnum = {
        Error: 'error',
        Pending: 'pending',
        Running: 'running',
        Success: 'success',
        Generating: 'generating',
        Cancelled: 'cancelled'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


